module.exports = __webpack_public_path__ + "media/src/images/mails/badge_sop-f8a68f751bc8f8a727afd9308532836a.png";